<div class="wrapper" style="height:100%;">
    <app-main-header></app-main-header>
    <app-main-sidebar></app-main-sidebar>
    <app-content-wrapper></app-content-wrapper>
    <app-control-sidebar></app-control-sidebar>
    <app-main-footer></app-main-footer>
</div>
